import { Layout, theme, Button } from 'antd';
import React, { useCallback, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from 'src/components/Header';
import SideBar from './Sidebar';
import WithAuth from 'src/components/with-auth';
import RequireAccess from 'src/components/require-access';
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';

const { Content, Footer } = Layout;

const SideBarLayout = () => {
  const { token } = theme.useToken();
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      // Only auto-collapse on very small screens
      if (window.innerWidth <= 576) {
        setCollapsed(true);
      }
    };

    // Set initial state
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleCollapsed = useCallback(value => {
    setCollapsed(value);
  }, []);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <WithAuth redirectTo={'/auth/login'}>
      <Layout>
        <Header />
        <Layout>
          <SideBar collapsed={collapsed} handleCollapsed={handleCollapsed} />
          <Content
            style={{
              marginLeft: collapsed ? 0 : (isMobile ? 0 : token.Layout.siderWidth),
              transition: 'all 0.2s ease'
            }}
          >
            <Button
              type="primary"
              onClick={toggleSidebar}
              size="large"
              style={{
                position: 'fixed',
                top: token.Layout.headerHeight + 10,
                left: collapsed ? 15 : (isMobile ? 15 : token.Layout.siderWidth + 15),
                zIndex: 1001,
                transition: 'all 0.2s ease',
                background: '#0868f8',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              icon={collapsed ? <MenuUnfoldOutlined style={{ fontSize: '18px' }} /> : <MenuFoldOutlined style={{ fontSize: '18px' }} />}
            />
            <div style={{ 
              padding: isMobile ? '15px' : '20px', 
              paddingTop: '60px',
              marginLeft: isMobile ? 0 : 10
            }}>
              <RequireAccess>
                <Outlet />
              </RequireAccess>
            </div>
            <Footer />
          </Content>
        </Layout>
      </Layout>
    </WithAuth>
  );
};

export default SideBarLayout;
